import { sdkRequest } from '@eventbrite/http';
import { gettext } from '@eventbrite/i18n';

export const STANDARD_SERVER_ERROR = gettext(
    'There was an issue with the server, try again',
);
export interface AssortmentResponse {
    user_id: string;
    plan: AssortmentPlan;
}

export enum AssortmentPlan {
    PACKAGE_TWO = 'package2',
}

const getAssortmentApiUrl = (organizationId: string): string =>
    `/api/v3/organizations/${organizationId}/assortment/`;

export const setAssortment = (
    organizationId: string,
    plan: AssortmentPlan = AssortmentPlan.PACKAGE_TWO,
): Promise<AssortmentResponse> =>
    sdkRequest(getAssortmentApiUrl(organizationId), {
        method: 'POST',
        body: JSON.stringify({ plan }),
    });
